<div class="content grid-1">
  <article *ngIf="usersLoaded; else loadingTemplate">
    <!--  TODO: add a section showing the admin users  -->
    <h2 class="heading-underline">
      Users
    </h2>
    <table class="table table-striped">
      <tr>
        <th>Name</th>
        <th>ID</th>
        <th>Email</th>
        <th></th>
      </tr>
      <tr *ngFor="let user of users">
        <td>{{user.name}}</td>
        <td>{{user.id}}</td>
        <td>{{user.email}}</td>
        <td>
          <button *ngIf="!user.admin" class="btn btn-danger" (click)="deleteUserInDynamo(user.id)">Delete User</button>
          <span *ngIf="user.admin">Admin</span>
        </td>
      </tr>
    </table>
    <section>
      <h3>Add New</h3>
      <div class="form-inline">
        <!--TODO Change the component to add Bullhorn search functionality-->
        <select [(ngModel)]="selectedUser" class="custom-select custom-select-lg mb-3 mr-sm-3">
          <option *ngFor="let bullhornUser of bullhornUsers let i = index" [value]="bullhornUsers[i].id">
            {{bullhornUser.name}}
          </option>
        </select>
        <button class="btn btn-success mb-3" (click)="addUserInDynamo({userId: selectedUser})">
          Add
        </button>
      </div>
    </section>
  </article>
</div>
<ng-template #loadingTemplate>
  <app-loading></app-loading>
</ng-template>
